import { useJsApiLoader } from '@react-google-maps/api';

const LIBRARIES = ['places'];

export function useGoogleMaps() {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY || '',
    libraries: LIBRARIES,
  });
  return { isLoaded, loadError };
}
